import { render, staticRenderFns } from "./SpecimensToSale.vue?vue&type=template&id=5cbdd83b"
import script from "./SpecimensToSale.vue?vue&type=script&lang=js"
export * from "./SpecimensToSale.vue?vue&type=script&lang=js"
import style0 from "./SpecimensToSale.vue?vue&type=style&index=0&id=5cbdd83b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports